import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Dialog, DialogActions, DialogContent } from '@mui/material';
import { FieldValues, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import { VerificationAgencyClientService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { VerificationAgencyClient } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { CustomDialogTitle } from '../../Common/Custom/CustomDialogTitle';
import { CompanyDetailsValidationSchema } from '../Details/CompanyDetailsValidationSchema';

interface IProps {
    showClientModal: boolean;
    closeClientModal: () => void;
}

export const ClientModal = (props: IProps) => {

    const [verificationCompany, setVerificationCompany] = useRecoilState(VerificationCompanyAtom);
    const history = useHistory();

    const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(CompanyDetailsValidationSchema),
    });

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                companyName: data.companyName,
                registrationNumber: data.registrationNumber
            } as VerificationAgencyClient.CompanyDetailsCreateDtoIn;

            const response = await VerificationAgencyClientService.CreateEntry(requestData);
            setVerificationCompany({ ...verificationCompany, vaClientId: response.data.vaClientId });
            toast.success("Successfully added client");
            history.push("/company/details/company");
        } catch (error: any) {
            console.log(error);
            toast.error(error.response.data);
        }
    }

    const closeModal = () => {
        props.closeClientModal();
        reset();
    }

    return (
        <Dialog disableEnforceFocus open={props.showClientModal} onClose={() => { closeModal() }} aria-labelledby="form-dialog-title">
            <CustomDialogTitle id="add-client-dialog-title" onClose={() => closeModal()}>
                Add Client
            </CustomDialogTitle>
            <DialogContent sx={{ width: '500px' }}>
                <form id='addClientForm' onSubmit={handleSubmit(handleDataSubmit)}>
                    <Box mt={2}>
                        <AppTextInput control={control} name="companyName" label="Client Name" size={"small"} />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="registrationNumber" label="Registration Number" size={"small"} />
                    </Box>
                </form>
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={isSubmitting} variant='contained' form='addClientForm' type="submit" color='primary' >
                    Add
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}